import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const adminGuard: CanActivateFn = () => {
  const router = inject(Router);
  const authService = inject(AuthService);

  if (authService.isAdminOrRoot()) {
    return true;
  }

  return router.parseUrl('/home');
};

export const scheduleManagerGuard: CanActivateFn = () => {
  const router = inject(Router);
  const authService = inject(AuthService);

  if (authService.canManageSchedule()) {
    return true;
  }

  return router.parseUrl('/employees');
};
